import { render, staticRenderFns } from "./index.vue?vue&type=template&id=332e3b0d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=332e3b0d&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('332e3b0d')) {
      api.createRecord('332e3b0d', component.options)
    } else {
      api.reload('332e3b0d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=332e3b0d&", function () {
      api.rerender('332e3b0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/un-platform-participation/index.vue"
export default component.exports